import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinNonEmpty',
  pure: true,
  standalone: false
})
export class JoinNonEmptyPipe implements PipeTransform {
  transform(values: (string | null | undefined)[], separator: string = ', '): string {
    return values.filter(Boolean).join(separator);
  }
}
